<template>
    <v-tabs
        v-model="selectedTab"
        @change="onTabChange"
    >
        <v-tab
            v-for="(tab) in tabEnums"
            :key="tab.key"
            :value="tab.key"
        >
            {{ tab.text }}
        </v-tab>
    </v-tabs>
</template>

<script>

// 此处几个const变量定义移动到了 created 中。

export default {
    components: {},
    data() {
        return {
            selectedTab: '',
        };
    },
    computed: {
        tabEnums() {
            // 这是之前的代码。为了适配客服去框架机，将代码移动到此处。
            const isYX = window.data.set.currentClass === 'yx' || window.data.set.current == '10074';
            const isMarket = window.data.info.kfuin == '2852150878' || window.data.info.kfuin == '2852150212' || window.data.info.kfuin == '2355009885' || window.data.info.kfuin == '2852199659' || window.data.info.kfuin == '2885772560';
            const isYXSaaS = isYX && !(window.isPrivate || (window.env === 'private'));

            if (isYXSaaS) {
                return [
                    { key: '/mp/keywordReply', text: this.$t('关键词') },
                    { key: '/mp/msgReply', text: this.$t('新消息') },
                    { key: '/mp/welcomeReply', text: this.$t('加关注') },
                    { key: '/mp/menu', text: this.$t('自定义菜单') },
                    { key: '/mp/channels', text: this.$t('渠道二维码') },
                    { key: '/mp/invitation', text: this.$t('邀约二维码') },
                ];
            }
            const list = [
                { key: '/mp/keywordReply', text: this.$t('关键词') },
                { key: '/mp/msgReply', text: this.$t('新消息') },
                { key: '/mp/welcomeReply', text: this.$t('加关注') },
                { key: '/mp/menu', text: this.$t('自定义菜单') },
            ];
            if (isMarket) {
                list.push({ key: '/mp/invitation', text: this.$t('邀约二维码') });
            }
            return list;
        },
    },
    watch: {},
    created() {
        const { pathname } = window.location;
        const tab = this.tabEnums.find(item => pathname.indexOf(item.key) >= 0);
        this.selectedTab = tab.key;
    },
    mounted() {},
    methods: {
        onTabChange(value)  {
            const currentPath = window.location.pathname;
            if (currentPath !== value) {
                // 当前页面跟目标页面一样时，重新设置pathname也会导致未保存提示，所以要避免提示
                window.location.pathname = value;
            }
            if (currentPath === '/mp/menu') {
                // 因为自定义菜单要做未保存提示，提示弹出后无法获取返回值，所以要保持自定义菜单选中，如果用户离开，新页面会重新渲染选中的tab，
                setTimeout(() => {
                    this.selectedTab = '/mp/menu';
                });
            }
        },
    },
};
</script>
<style lang="less" scoped>
</style>
